import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/** Renders children only for main store users (no consignment location). Otherwise redirects to home. */
export default function MainStoreRoute({ children }) {
  const { isMainStore, isPicker, isAdmin, loading } = useAuth();
  if (loading) return null;
  if (!isAdmin && !isPicker && !isMainStore) return <Navigate to="/" replace />;
  return children;
}
